<template>
    <div class="contact-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-bg" style="background-image: url('https://picsum.photos/id/1053/1920/400');"></div>
            <div class="header-content">
                <h1>联系我们</h1>
                <p>如有任何疑问或需求，请随时与我们联系</p>
            </div>
        </div>

        <!-- 联系信息 -->
        <section class="contact-info-section">
            <div class="container">
                <h2>联系方式</h2>
                <div class="contact-info-grid">
                    <div class="contact-info-item">
                        <div class="info-icon">
                            <i class="fa fa-map-marker"></i>
                        </div>
                        <div class="info-content">
                            <h3>公司地址</h3>
                            <p>{{ companyInfo.address || '四川省成都市高新区天府大道123号' }}</p>
                        </div>
                    </div>
                    <div class="contact-info-item">
                        <div class="info-icon">
                            <i class="fa fa-phone"></i>
                        </div>
                        <div class="info-content">
                            <h3>联系电话</h3>
                            <p>{{ companyInfo.phone || '028-12345678' }}</p>
                        </div>
                    </div>
                    <div class="contact-info-item">
                        <div class="info-icon">
                            <i class="fa fa-envelope"></i>
                        </div>
                        <div class="info-content">
                            <h3>电子邮箱</h3>
                            <p>{{ companyInfo.email || 'info@boletech.com' }}</p>
                        </div>
                    </div>
                    <div class="contact-info-item">
                        <div class="info-icon">
                            <i class="fa fa-clock-o"></i>
                        </div>
                        <div class="info-content">
                            <h3>工作时间</h3>
                            <p>周一至周五: 9:00 - 17:00</p>
                            <p>周六至周日: 休息</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 联系表单和地图 -->
        <section class="contact-form-section">
            <div class="container">
                <div class="contact-content">
                    <div class="contact-form">
                        <h2>发送消息</h2>
                        <form @submit.prevent="submitMessage">
                            <div class="form-group">
                                <label for="name">您的姓名 <span class="required">*</span></label>
                                <input type="text" id="name" v-model="message.name" placeholder="请输入您的姓名" required>
                            </div>
                            <div class="form-group">
                                <label for="phone">联系电话 <span class="required">*</span></label>
                                <input type="tel" id="phone" v-model="message.phone" placeholder="请输入您的联系电话" required>
                            </div>
                            <div class="form-group">
                                <label for="email">电子邮箱</label>
                                <input type="email" id="email" v-model="message.email" placeholder="请输入您的电子邮箱">
                            </div>
                            <div class="form-group">
                                <label for="content">留言内容 <span class="required">*</span></label>
                                <textarea id="content" v-model="message.content" placeholder="请输入您的留言内容" rows="5" required></textarea>
                            </div>
                            <button type="submit" class="submit-btn">发送留言</button>
                        </form>
                    </div>

                    <div class="contact-map">
                        <h2>公司位置</h2>
                        <div class="map-container">
                            <!-- 静态地图图片 -->
                            <img src="https://picsum.photos/id/1015/800/400" alt="公司位置地图">
                        </div>
                        <div class="map-desc">
                            <p>我们位于成都市瑞鑫时代大厦A座，交通便利，欢迎前来参观洽谈。</p>
                            <p>如有需要，可提前电话联系我们，我们将安排专人接待。</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
// 关键：从api/index.js导入需要的API
import { companyApi, contactApi } from '@/api/index.js'  // 明确指定index.js
export default {
    name: 'ContactPage',
    data() {
        return {
            companyInfo: {},
            message: {
                name: '',
                phone: '',
                email: '',
                content: ''
            }
        }
    },
    mounted() {
        this.getCompanyInfo()
    },
    methods: {
        // 获取公司信息
        getCompanyInfo() {
            companyApi.getCompanyInfo().then(res => {
                if (res) {
                    this.companyInfo = res.data
                }
            }).catch(err => {
                console.error('获取公司信息失败:', err)
            })
        },

        // 提交留言
        submitMessage() {
            contactApi.submitContact(this.message).then(res => {
                if (res) {
                    // 显示成功提示
                    this.$message.success('留言发送成功，我们会尽快与您联系！')
                    // 清空表单
                    this.message = {
                        name: '',
                        phone: '',
                        email: '',
                        content: ''
                    }
                }
            }).catch(err => {
                console.error('留言发送失败:', err)
                this.$message.error('留言发送失败，请稍后重试')
            })
        }
    }
}
</script>

<style scoped>
.page-header {
    position: relative;
    height: 400px;
    overflow: hidden;
}

.header-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    filter: brightness(0.6);
}

.header-content {
    position: relative;
    z-index: 2;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    text-align: center;
}

.header-content h1 {
    font-size: 3rem;
    margin-bottom: 15px;
}

.header-content p {
    font-size: 1.2rem;
}

section {
    padding: 80px 0;
}

.container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

h2 {
    font-size: 2rem;
    color: #2c3e50;
    margin-bottom: 40px;
    text-align: center;
    position: relative;
    display: inline-block;
    left: 50%;
    transform: translateX(-50%);
    padding-bottom: 10px;
}

h2::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: #165DFF;
}

/* 联系信息样式 */
.contact-info-section {
    background-color: #f9f9f9;
}

.contact-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
}

.contact-info-item {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s;
}

.contact-info-item:hover {
    transform: translateY(-10px);
}

.info-icon {
    width: 70px;
    height: 70px;
    background-color: #f0f5ff;
    color: #165DFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
    font-size: 1.8rem;
}

.info-content h3 {
    font-size: 1.3rem;
    color: #2c3e50;
    margin-bottom: 15px;
}

.info-content p {
    color: #7f8c8d;
    line-height: 1.6;
    margin: 0;
}

/* 联系表单和地图样式 */
.contact-form-section {
    background-color: #fff;
}

.contact-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
}

.contact-form h2,
.contact-map h2 {
    text-align: left;
    display: block;
    left: 0;
    transform: none;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    color: #2c3e50;
    font-weight: 500;
}

.required {
    color: #ff4d4f;
}

.form-group input,
.form-group textarea {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 1rem;
    transition: border-color 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #165DFF;
}

.submit-btn {
    padding: 12px 30px;
    background-color: #165DFF;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.submit-btn:hover {
    background-color: #0E42D2;
}

.map-container {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;
}

.map-container img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

.map-desc p {
    color: #7f8c8d;
    line-height: 1.8;
    margin-bottom: 15px;
}

/* 响应式样式 */
@media (max-width: 992px) {
    .contact-content {
        grid-template-columns: 1fr;
    }

    .contact-form h2,
    .contact-map h2 {
        text-align: center;
        display: inline-block;
        left: 50%;
        transform: translateX(-50%);
    }
}

@media (max-width: 768px) {
    .header-content h1 {
        font-size: 2.2rem;
    }

    h2 {
        font-size: 1.8rem;
    }
}

@media (max-width: 576px) {
    .page-header {
        height: 300px;
    }

    .header-content h1 {
        font-size: 1.8rem;
    }

    .header-content p {
        font-size: 1rem;
    }

    section {
        padding: 50px 0;
    }

    .map-container img {
        height: 300px;
    }
}
</style>
